<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <!-- comment -->
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style=" border-radius: 5px !important;padding-left:0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="previousAir" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Air Freight Execution Import</b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <b-button style="padding-right:2px" variant="success" size="sm" @click="showDO">DO &
              Cargo(Documentation)</b-button>

            <b-button style="margin-left:10px" variant="success" size="sm" @click="showNoc">NOC &
              Auth.(Documentation)</b-button>
            <b-button style="margin-left:10px" variant="success" size="sm" class="pull-right"
              @click="proceedToTally">Proceed To Invoice</b-button>
          </b-navbar-nav>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <md-layout md-gutter class="labelMargtop">

              <md-layout md-flex="35">
                <md-layout md-flex="100">
                  <label>Assignment No.</label>
                  <b-form-input :formatter="capitalizeAll" name="airImportSeries" id="airImportSeries"
                    v-model="mainPageModal.airImportSeries" disabled></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="labelMargtop">

              <md-layout md-flex="35">
                <label for="bookingShipment">Booking Transhipment</label>
                <model-list-select option-value="bookingShipmentVal" option-text="bookingShipmentText"
                  :list="bookingShipmentList" placeholder="Select Booking Transhipment"
                  v-model="BookingShippingLine.bookingShipment"
                  :isDisabled="tentativeDetailArray.length == 0?false:true"></model-list-select>

                <span class="error"
                  v-if="!BookingShippingLine.bookingShipment">{{errorBookingShippingLine.bookingShipment}}</span>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="labelMargtop">

              <md-layout md-flex="30">
                <b-button variant="outline-info" size="sm" v-if="BookingShippingLine.bookingShipment=='yes'"
                  @click="showAddAirportmet">Click here to {{showAddAirport==false?"Add ":"Hide"}}
                  Transhipment</b-button>
              </md-layout>
            </md-layout>

            <div class="gutr" v-if="BookingShippingLine.bookingShipment=='yes' && showAddAirport==true"
              id="TranshipmentDetail">

              <b-card style="background:whiteSmoke">
                <md-layout md-gutter class="labelMargtop">

                  <md-layout md-flex="30">
                    <label for="fromPort">From Port</label>
                    <model-list-select @input="getLocationList($event,'Air_Port','portListFP')"
                      @searchchange="getLocationList($event,'Air_Port','portListFP')" option-value="pickupId"
                      option-text="pickupLocation" :list="portListFP" placeholder="Select Port Name"
                      v-model="moreAirportModel.fromPort"></model-list-select>
                    <span class="error" v-if="!moreAirportModel.fromPort">{{errorAirport.fromPort}}</span>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="30">
                    <label for="toPort">To Port</label>
                    <model-list-select @input="getLocationList($event,'Air_Port','portListTP')"
                      @searchchange="getLocationList($event,'Air_Port','portListTP')" option-value="pickupId"
                      option-text="pickupLocation" :list="portListTP" placeholder="Select Port Name"
                      v-model="moreAirportModel.toPort"></model-list-select>
                    <span class="error" v-if="!moreAirportModel.toPort">{{errorAirport.toPort}}</span>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="30">
                    <label>Flight No.</label>
                    <b-form-input :formatter="capitalizeAll" name="flightNo1" id="flightNo1"
                      v-model="moreAirportModel.flightNo"></b-form-input>

                    <span class="error" v-if="!moreAirportModel.flightNo">{{errorAirport.flightNo}}</span>
                  </md-layout>
                </md-layout>

                <md-layout gutter class="labelMargtop">

                  <md-layout md-flex="20">
                    <label>ETD(From Port)</label>
                    <date-picker :format="selectDateFormat" lang="en" id="etdFromPort1" name="etdFromPort1"
                      v-model="moreAirportModel.etdFromPort"></date-picker>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="15">
                    <md-layout>
                      <label>ETA(To Port)</label>
                    </md-layout>

                    <date-picker :format="selectDateFormat" lang="en" id="etaToPort1" name="etaToPort1"
                      v-model="moreAirportModel.etaToPort"></date-picker>
                    <span class="error" v-if="!moreAirportModel.etaToPort">{{errorAirport.etaToPort}}</span>
                  </md-layout>

                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <b-button variant="info" size="sm" @click="addTrans" id="addButtonLoader1"
                      style="margin-top:35px">{{moreAirportModel.multiTransAirExexId==""?"Add":"edit"}}
                      Airport</b-button>
                  </md-layout>
                </md-layout>
              </b-card>

            </div>
            <div class="mt-3" v-if="tentativeDetailArrayList.length>0">
              <h5>
                <b-badge>Transhipment Details</b-badge>
              </h5>


              <!-- /.box-header -->
              <div class="box-body">
                <table id="ffBookingTentative" class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th>From Port</th>
                      <th>To Port</th>
                      <th>ETD (From Port)</th>
                      <th>ETA (To Port)</th>
                      <!-- <th>Item Number</th> -->
                      <th>Edit</th>
                      <!--  <th>Delete</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item,index) in tentativeDetailArrayList" :key="index">
                      <td>{{index+1}}</td>
                      <td>{{item.fromportName }}</td>
                      <td>{{item.toportName }}</td>
                      <td>{{item.etdFromPort | moment}}</td>
                      <td>{{item.etaToPort | moment}}</td>

                      <td>
                        <md-button class="md-icon-button md-raised md-dense" @click="viewEdit(item,index)">
                          <md-icon>edit</md-icon>
                        </md-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- /.box-body -->
            </div>

            <md-layout md-gutter class="labelMargtop">

              <md-layout md-flex="30">
                <label for="fromPort">From Port</label>
                <model-list-select @input="getLocationList($event,'Air_Port','portListFPT')"
                  @searchchange="getLocationList($event,'Air_Port','portListFPT')" option-value="pickupId"
                  option-text="pickupLocation" :list="portListFPT" placeholder="Select Port Name"
                  v-model="BookingShippingLine.fromPort"></model-list-select>

                <span class="error" v-if="!BookingShippingLine.fromPort">{{errorBookingShippingLine.fromPort}}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <label for="toPort">To Port</label>
                <model-list-select @input="getLocationList($event,'Air_Port','portListTPT')"
                  @searchchange="getLocationList($event,'Air_Port','portListTPT')" option-value="pickupId"
                  option-text="pickupLocation" :list="portListTPT" placeholder="Select Port Name"
                  v-model="BookingShippingLine.toPort"></model-list-select>
                <span class="error" v-if="!BookingShippingLine.toPort">{{errorBookingShippingLine.toPort}}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <label>Flight No.</label>
                <b-form-input :formatter="capitalizeAll" name="flightNo" id="flightNo"
                  v-model="BookingShippingLine.flightNo"></b-form-input>

                <span class="error" v-if="!BookingShippingLine.flightNo">{{errorBookingShippingLine.flightNo}}</span>
              </md-layout>
            </md-layout>

            <md-layout gutter class="labelMargtop">

              <md-layout md-flex="20">
                <label>ETD(From Port)</label>
                <date-picker :format="selectDateFormat" lang="en" id="etdFromPort" name="etdFromPort"
                  v-model="BookingShippingLine.etdFromPort"></date-picker>
                <span class="error"
                  v-if="!BookingShippingLine.etdFromPort">{{errorBookingShippingLine.etdFromPort}}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <label>ETA(To Port)</label>
                <date-picker :format="selectDateFormat" lang="en" id="etaToPort" name="etaToPort"
                  v-model="BookingShippingLine.etaToPort"></date-picker>
                <span class="error" v-if="!BookingShippingLine.etaToPort">{{errorBookingShippingLine.etaToPort}}</span>
              </md-layout>
            </md-layout>

            <md-layout gutter class="labelMargtop">

              <md-layout md-flex="20">
                <label>IGM Filing Date</label>
                <date-picker :format="selectDateFormat" lang="en" id="igmFilingDate" name="igmFilingDate"
                  v-model="BookingShippingLine.igmFilingDate"></date-picker>
                <span class="error"
                  v-if="!BookingShippingLine.igmFilingDate">{{errorBookingShippingLine.igmFilingDate}}</span>
              </md-layout>
            </md-layout>
            <md-layout gutter class="labelMargtop">

              <md-layout md-flex="30">
                <label>IGM No.</label>
                <b-form-input :formatter="capitalizeAll" name="gatewayIgmNo" id="gatewayIgmNo"
                  v-model="BookingShippingLine.gatewayIgmNo"></b-form-input>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <label>IGM Date</label>
                <date-picker :format="selectDateFormat" lang="en" id="gatewayIgmDate" name="gatewayIgmDate"
                  v-model="BookingShippingLine.gatewayIgmDate"></date-picker>
              </md-layout>
            </md-layout>

            <md-layout gutter v-for="(item,index) in multiHAWBL" :key="index" class="labelMargtop">


              <md-layout md-flex="30">
                <label for="clientId">HAWBL No.</label>

                <b-form-input :formatter="capitalizeAll" :value="item.secondBLNumber" disabled></b-form-input>
              </md-layout>

              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="20">
                <label>SMTP No.</label>
                <b-form-input :formatter="capitalizeAll" name="smtpNo" id="smtpNo"
                  v-model="smtpNo[index]"></b-form-input>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="gutr">

              <md-layout md-flex="30">
                <b-button class="mt-3" variant="primary" id="addButtonLoader1" @click="addExec">Save & Proceed To
                  Tracking</b-button>
                <md-spinner md-indeterminate id="loader1" style="display:none"></md-spinner>
              </md-layout>
            </md-layout>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" @close="onClose6"
      ref="addPop6"></md-dialog-confirm>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop2"
      @close="onCloseProceed"></md-dialog-confirm>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import axios from "axios";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation
} from "../../helper/collection";
import VueTrix from "vue-trix";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import CustomLoader from "../common/customLoader.vue";

import { quillEditor } from "vue-quill-editor";

export default {
  beforeMount() {
    if (globalPermissionStatus("Air Freight")) {
      this.$store.dispatch("setCurrentRoute", "/airImport/airImportExec");

      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }

    // this.vehicle();
  },
  beforeDestroy() {},
  data() {
    return {
      selectDateFormat,
      editorOption: {
        modules: {}
      },
      editorContent: "",
      isLoading: false,
      bookingShipmentName: [
        {
          bookingShipmentVal: "yes",
          bookingShipmentText: "Yes"
        },
        {
          bookingShipmentVal: "no",
          bookingShipmentText: "No"
        }
      ],

      deStuffingLocationequal: [
        {
          deStuffingLocationequalVal: "Port",
          deStuffingLocationequalText: "Port"
        },
        {
          deStuffingLocationequalVal: "Factory",
          deStuffingLocationequalText: "Factory"
        }
      ],
      deStuffingLocationNequal: [
        {
          deStuffingLocationequalNVal: "CFS_ICD",
          deStuffingLocationequalNText: "CFS / ICD"
        },
        {
          deStuffingLocationequalNVal: "Factory",
          deStuffingLocationequalNText: "Factory"
        }
      ],

      value12: "",
      getCLientData: ["gfdg"],
      multiHAWBL: [],
      smtpNo: [],

      BookingShippingLine: {
        ffairImpExecId: "",
        ffairImportId: this.$sessionsStorage.get("editffAirImportId"),
        multiTransAirExexId: "",
        fromPort: "",
        toPort: "",
        smtpNo: "",
        etdFromPort: "",
        etaToPort: "",
        flightNo: "",
        bookingShipment: "",
        igmFilingDate: "",
        gatewayIgmNo: "",
        gatewayIgmDate: ""
      },
      execError: [
        "Select Transhipment",
        "Select IGM Filing Date",
        "Select From Port",
        "Select To Port",
        "Select ETD Date",
        "Select ETA Date",
        "Enter Flight No"
      ],
      errorBookingShippingLine: {
        bookingShipment: "",
        igmFilingDate: "",
        fromPort: "",
        toPort: "",
        etdFromPort: "",
        etaToPort: "",
        flightNo: ""
      },

      //  tentativePortNameFull: {},
      portMasterList: [],
      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      mainPageModal: {
        PODLocationId: "",
        finalPlaceLocationId: "",
        firstBlType: "",
        secondBlType: "",
        firstBLRadio: "",
        containerInfo: "",
        airImportSeries: ""
      },

      moreAirportModel: {
        multiTransAirExexId: "",
        ffairImpExecId: "",
        ffairImportId: this.$sessionsStorage.get("editffAirImportId"),
        fromPort: "",
        toPort: "",
        etaFromPort: "",
        etaToPort: "",
        flightNo: ""
      },

      portListFP: [],
      portListTP: [],
      portListFPT: [],
      portListTPT: [],
      tentativeDetailArray: [],
      HAWBArray: [],
      agentMasterList: [],
      deleteId: "",
      validate: true,
      validateTrans: true,
      arrayErrorAirport: [
        "Select From Port",
        "Select To Port",

        "Select ETA Date",
        "Enter Flight No"
      ],
      errorAirport: {
        fromPort: "",
        toPort: "",

        etaToPort: "",
        flightNo: ""
      },
      showAddAirport: false,

      editIndex: ""
    };
  },

  mounted() {},
  watch: {},
  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },

  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    Loading,
    VueTrix,
    CustomLoader,
    quillEditor
  },
  computed: {
    clientList() {
      return this.getCLientData;
    },

    uploadBookingStatus() {
      return this.BookingShippingLine.uploadBooking != ""
        ? this.BookingShippingLine.uploadBooking.split(",")
        : [];
    },
    tentativeDetailArrayList() {
      return this.tentativeDetailArray;
    },
    portList() {
      return this.portMasterList;
    },

    bookingShipmentList() {
      return this.bookingShipmentName;
    }
  },
  methods: {
    proceedToTally() {
      // this.$sessionsStorage.set("airInvoiceType", '2')

      this.$router.push({
      path: "/airImport/airFreightImportInvoice?JobType=FF&ShipmentType=Air&ModuleType=Import"
      });
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function(error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    showAddAirportmet() {
      if (this.showAddAirport == false) {
        this.showAddAirport = true;
      } else {
        this.showAddAirport = false;
      }
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    onCloseProceed() {
      this.$router.push({
        path: "/airImport/airImportTracking"
      });
    },
    onClose6(type) {},

    viewEdit(item, index) {
      this.showAddAirport = true;
      Object.keys(this.moreAirportModel).map(x => {
        this.moreAirportModel[x] = item[x];
      });
    },
    DeleteList(item, index) {
      this.deleteId = item.moreAirportId;
      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop6"].open();
    },
    previousAir() {
      this.$router.push({
        path: "/airImport/ffairImportFcl"
      });
    },

    validateAddAirport() {
      let validate_new = true;

      Object.keys(this.errorAirport).map((x, index) => {
        if (this.moreAirportModel[x] == "") {
          this.errorAirport[x] = this.arrayErrorAirport[index];
          validate_new = false;
        }
      });

      if (validate_new != true) {
        this.validateTrans = false;
      } else {
        this.validateTrans = true;
      }
    },
    addTrans() {
      this.BookingShippingLine["smtpNo"] = "";

      this.smtpNo.map(x => {
        this.BookingShippingLine["smtpNo"] += x + ",";
      });

      this.BookingShippingLine["ffairImportId"] = this.$sessionsStorage.get(
        "editffAirImportId"
      );

      this.validateAddAirport();
      if (this.validateTrans != false) {
        let newData = {
          moreAirportModel: this.moreAirportModel,
          BookingShippingLine: this.BookingShippingLine,
          onlyExecMain: ""
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_AirImport/addTranshipmentAirExec.php`,
          data: JSON.stringify(newData),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;

            if ( status == 200 && data) {
              console.log(data);
              this.BookingShippingLine.ffairImpExecId = data.ffairImpExecId;
              this.$sessionsStorage.set(
                "editAirImpExecId",
                data.ffairImpExecId
              );

              Object.keys(this.moreAirportModel).map(x => {
                this.moreAirportModel[x] = "";
              });
              //   Object.keys(this.errorMoreAirport).map(x => {
              //     this.errorMoreAirport[x] = "";
              //   });
              this.showAddAirport = false;
              this.getData();
            }
          })
          .catch(error => {});
      }
    },

    validateExec() {
      let validate_new = true;

      Object.keys(this.errorBookingShippingLine).map((x, index) => {
        if (this.BookingShippingLine[x] == "") {
          this.errorBookingShippingLine[x] = this.execError[index];
          validate_new = false;
        }
      });

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    addExec() {
      this.BookingShippingLine["smtpNo"] = "";

      this.smtpNo.map(x => {
        this.BookingShippingLine["smtpNo"] += x + ",";
      });
      this.BookingShippingLine[
        "transhipmentDetail"
      ] = this.tentativeDetailArray;

      this.validateExec();

      if (this.validate != false) {
        $("#addButtonLoader1").css("display", "none");
        $("#loader1").css("display", "block");

        let newData = {
          moreAirportModel: this.moreAirportModel,
          BookingShippingLine: this.BookingShippingLine,
          onlyExecMain: "fdsfdsf"
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_AirImport/addTranshipmentAirExec.php`,
          data: JSON.stringify(newData),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;

            if ( status == 200 && data) {
              $("#loader1").css("display", "none");
              $("#addButtonLoader1").css("display", "block");

              if (this.BookingShippingLine.ffairImpExecId == "") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
              }
              this.BookingShippingLine.ffairImpExecId = data.ffairImpExecId;
              this.$sessionsStorage.set(
                "editAirImpExecId",
                data.ffairImpExecId
              );

              this.$refs["addPop2"].open();
              this.getData();
            }
          })
          .catch(error => {});
      }
    },
    showDO() {
      this.$router.push({
        path: "/airImport/DOorderDocumentation"
      });
    },
    showNoc() {
      this.$router.push({
        path: "/airImport/documentation"
      });
    },
    // JqueryFun() {
    //   return $(function() {
    //     return $("#ffBookingTentative").DataTable();
    //   });
    // },
    getData() {
      this.doLoading();
      if (this.tentativeDetailArray.length == 1) {
        this.tentativeDetailArray = [];
      }
      let new_data = {
        ffairImportId: this.$sessionsStorage.get("editffAirImportId")
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_AirImport/fetchToAirImportExec1.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;

          if ( status == 200 && data) {
            console.log(data);
            if (data.portLocationArray.length > 0) {
              this.portMasterList = data.portLocationArray.filter(x => {
                return x.locationType == "Air_Port";
              });
            }
            if (data.airImportData.length > 0) {
              Object.keys(this.mainPageModal).map(x => {
                this.mainPageModal[x] = data.airImportData[0][x] || "";
              });
            }
            if (data.AirImportExecData.length > 0) {
              Object.keys(this.BookingShippingLine).map(x => {
                if (x == "smtpNo") {
                  this.smtpNo = data.AirImportExecData[0][x].split(",");
                }
                this.BookingShippingLine[x] =
                  data.AirImportExecData[0][x] || "";
              });
            } else {
              this.BookingShippingLine.fromPort =
                data.airImportData[0].PODLocationId;

              this.BookingShippingLine.toPort =
                data.airImportData[0].LPlocationId;
              this.BookingShippingLine.flightNo =
                data.airImportData[0].vesselVoyage;
            }

            this.portListFP = data.portLocationArray;
            this.portListTP = data.portLocationArray;
            this.portListFPT = data.portLocationArray;
            this.portListTPT = data.portLocationArray;

            if (data.airImportMultiHouseData.length > 0) {
              this.multiHAWBL = data.airImportMultiHouseData;
            }

            if (data.AirExecTranshipment.length > 0) {
              this.tentativeDetailArray = data.AirExecTranshipment;
            }
            this.doLoadingClose();
            //   this.JqueryFun();
          }
        })
        .catch(error => {});
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// airImportExec.vue?ebae98cc